import { render, staticRenderFns } from "./ProblemStatusEdit.vue?vue&type=template&id=04927a34&scoped=true"
import script from "./ProblemStatusEdit.vue?vue&type=script&lang=js"
export * from "./ProblemStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./ProblemStatusEdit.vue?vue&type=style&index=0&id=04927a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04927a34",
  null
  
)

export default component.exports